import { navigate } from '@reach/router'
import Sidebar from 'js/components-v2/pages/UserDashboard/Sidebar'
import AppContent from 'js/components/AppContent'
import { makeRequest } from 'js/services/Network'
import AppState from 'js/stores/AppState'
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState'
import React, { useState } from 'react'
import Content from '../Content'
import Button from './Components/Button'
import ItemGrid from './Components/ItemGrid'
import ItemTable from './Components/ItemTable'
import Pagination from '../../../../new/Components/App/Pagination'
import { debounce } from 'lodash'

const ItemsListPage = () => {
  const page = UserDashboardPageState.create()
  const [loading, setLoading] = useState(true)
  const [view, setView] = useState('table')
  const [items, setItems] = useState([])
  const [searchTerm, setSearchTerm] = useState('');

  React.useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage')
    await page.load()

    getData()
  }, [])

  React.useEffect(async () => {
    if (searchTerm !== null) {
      getData(1, searchTerm);
    }
  }, [searchTerm])

  const debouncedSearch = debounce((value, callback) => {
    callback(value);
  }, 300)

  const getData = async (page = 1, search = '') => {
    setLoading(true);

    const response = await makeRequest('my-items-data', null, {
      page: page,
      search: search,
      count: 10,
    })

    if (response.status === 200) {
      setItems(response.data.items)
    }

    setLoading(false)
  }

  return (
    <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
      <Sidebar currentPage='ItemsListPage' pageState={page} />

      <Content currentPage='ItemsListPage' showCards={false} className='new-pod-ui'>
        <div className='navbar tw-flex tw-justify-between tw-items-center mt-4'>
          <h4 className="dashboard-page__title tw-mb-0">Items</h4>

          <div className='tw-flex tw-gap-4'>
            <Button
              title="Add Item"
              onClick={() => { navigate('/dashboard/items/create') }}>
              <span className='tw-mr-4'>+</span> Add Item
            </Button>
          </div>
        </div>

        <div className="dashboard-page tw-space-y-4">
          <div className='tw-flex tw-justify-between tw-items-center'>
            <div className='tw-flex tw-gap-4 tw-border-2 tw-border-gray-100 tw-rounded-lg'>
              <button onClick={() => { setView('table') }} className='btn-plain'>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.16797 16.25H17.5013" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.16797 10.418H17.5013" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.16797 4.58203H17.5013" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.5 4.58464L3.33333 5.41797L5.83333 2.91797" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.5 10.4167L3.33333 11.25L5.83333 8.75" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.5 16.2487L3.33333 17.082L5.83333 14.582" stroke={view === 'table' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button onClick={() => { setView('grid') }} className='btn-plain'>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.16797 8.33464H5.83464C7.5013 8.33464 8.33464 7.5013 8.33464 5.83464V4.16797C8.33464 2.5013 7.5013 1.66797 5.83464 1.66797H4.16797C2.5013 1.66797 1.66797 2.5013 1.66797 4.16797V5.83464C1.66797 7.5013 2.5013 8.33464 4.16797 8.33464Z" stroke={view === 'grid' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.168 8.33464H15.8346C17.5013 8.33464 18.3346 7.5013 18.3346 5.83464V4.16797C18.3346 2.5013 17.5013 1.66797 15.8346 1.66797H14.168C12.5013 1.66797 11.668 2.5013 11.668 4.16797V5.83464C11.668 7.5013 12.5013 8.33464 14.168 8.33464Z" stroke={view === 'grid' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.168 18.3346H15.8346C17.5013 18.3346 18.3346 17.5013 18.3346 15.8346V14.168C18.3346 12.5013 17.5013 11.668 15.8346 11.668H14.168C12.5013 11.668 11.668 12.5013 11.668 14.168V15.8346C11.668 17.5013 12.5013 18.3346 14.168 18.3346Z" stroke={view === 'grid' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4.16797 18.3346H5.83464C7.5013 18.3346 8.33464 17.5013 8.33464 15.8346V14.168C8.33464 12.5013 7.5013 11.668 5.83464 11.668H4.16797C2.5013 11.668 1.66797 12.5013 1.66797 14.168V15.8346C1.66797 17.5013 2.5013 18.3346 4.16797 18.3346Z" stroke={view === 'grid' ? "#6D60F6" : "#6D6D6D"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <input
              type='search'
              placeholder='Search'
              className='tw-border-gray-100 tw-py-2 tw-px-4 tw-rounded-xl tw-border-solid'
              onChange={(e) => {
                debouncedSearch(e.target.value, setSearchTerm);
              }}
            />
          </div>

          {view === 'table'
            ? <ItemTable items={items?.data ?? []} />
            : <ItemGrid items={items?.data ?? []} />}

          {!items.total && loading && (
            <div className='tw-text-center tw-font-bold tw-p-5'>Loading items...</div>
          )}

          {items.total === 0 && !loading && (
            <div className='tw-text-center tw-font-bold tw-p-5'>You have no items yet.</div>
          )}

          <div className='tw-flex tw-justify-between tw-items-center'>
            <p>Showing {items.from ?? 0} to {items.to ?? 0} of {items.total ?? 0}</p>
            <Pagination
              currentPage={items.current_page ?? 1}
              totalPages={items.last_page ?? 1}
              onPageChange={(page) => getData(page, searchTerm)}
            />
          </div>
        </div>
      </Content>
    </AppContent>
  )
}

export default ItemsListPage
